import React from 'react';

// Paginación 100% frontend (recibe el total y controla page/perPage en el padre).
export default function RiskPagination({
    page, perPage, total, onPage, onPerPage,
    perPageOptions = [10, 25, 50, 100],
    showPerPage = true,
}) {
    if (!total) return null;

    const totalPages = Math.max(1, Math.ceil(total / perPage));
    const from = (page - 1) * perPage + 1;
    const to = Math.min(page * perPage, total);

    // ventana de hasta 5 páginas centrada en la actual
    const windowSize = 5;
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + windowSize - 1);
    start = Math.max(1, end - windowSize + 1);
    const pages = [];
    for (let i = start; i <= end; i++) pages.push(i);

    return (
        <div className="rk-pagination">
            <div className="rk-pagination__info">
                Mostrando <strong>{from}-{to}</strong> de <strong>{total}</strong>
            </div>

            <div className="rk-pagination__right">
                {showPerPage && (
                    <div className="rk-pagination__perpage">
                        <span>Por página:</span>
                        <select value={perPage} onChange={e => onPerPage(Number(e.target.value))}>
                            {perPageOptions.map(n => <option key={n} value={n}>{n}</option>)}
                        </select>
                    </div>
                )}

                <div className="rk-pagination__pages">
                    <button disabled={page <= 1} onClick={() => onPage(page - 1)} title="Anterior">
                        <i className="fas fa-angle-left"></i>
                    </button>

                    {start > 1 && <button onClick={() => onPage(1)}>1</button>}
                    {start > 2 && <span className="rk-pagination__dots">…</span>}

                    {pages.map(p => (
                        <button key={p} className={p === page ? 'is-active' : ''} onClick={() => onPage(p)}>{p}</button>
                    ))}

                    {end < totalPages - 1 && <span className="rk-pagination__dots">…</span>}
                    {end < totalPages && <button onClick={() => onPage(totalPages)}>{totalPages}</button>}

                    <button disabled={page >= totalPages} onClick={() => onPage(page + 1)} title="Siguiente">
                        <i className="fas fa-angle-right"></i>
                    </button>
                </div>
            </div>
        </div>
    );
}
